import React from "react";

const ReaderContext = React.createContext();

export default ReaderContext;
